import {
	SUPPLIER_COLORS,
	SUPPLIER_FALLBACK_COLOR,
	getSupplierColorIndex,
} from "@/shared/utils/supplierColors";
import { ExcelStyle } from "ag-grid-community";

export const EXCEL_TEXT_CLASS = "xl-text";
export const EXCEL_CENTER_CLASS = "xl-center";
export const EXCEL_BELOW_DETECTION_CLASS = "xl-below-detection";

export const supplierExcelClass = (supplier: string | null | undefined) => {
	const index = getSupplierColorIndex(supplier);
	return index === -1 ? "xl-supplier-none" : `xl-supplier-${index}`;
};

export const numberExcelClass = (decimals: number) => `xl-num-${decimals}`;

const BORDER = {
	lineStyle: "Continuous",
	weight: 0,
	color: "#d0d7de",
} as const;
const ALL_BORDERS = {
	borderTop: BORDER,
	borderBottom: BORDER,
	borderLeft: BORDER,
	borderRight: BORDER,
};

const supplierStyle = (id: string, color: string): ExcelStyle => ({
	id,
	font: { bold: true, color: "#FFFFFF" },
	interior: { color, pattern: "Solid" },
	alignment: { horizontal: "Center", vertical: "Center" },
	borders: ALL_BORDERS,
});

export const CHEMISTRY_EXCEL_STYLES: ExcelStyle[] = [
	{
		id: "header",
		font: { bold: true, color: "#FFFFFF", size: 11 },
		interior: { color: "#37474F", pattern: "Solid" },
		alignment: { horizontal: "Center", vertical: "Center" },
		borders: ALL_BORDERS,
	},
	{
		id: EXCEL_TEXT_CLASS,
		alignment: { horizontal: "Left", vertical: "Center" },
		borders: ALL_BORDERS,
	},
	{
		id: EXCEL_CENTER_CLASS,
		alignment: { horizontal: "Center", vertical: "Center" },
		borders: ALL_BORDERS,
	},
	...SUPPLIER_COLORS.map((color, index) =>
		supplierStyle(`xl-supplier-${index}`, color),
	),
	supplierStyle("xl-supplier-none", SUPPLIER_FALLBACK_COLOR),
	...[2, 3, 4].map(
		(decimals): ExcelStyle => ({
			id: numberExcelClass(decimals),
			numberFormat: { format: `0.${"0".repeat(decimals)}` },
			alignment: { horizontal: "Right", vertical: "Center" },
			borders: ALL_BORDERS,
		}),
	),
	{
		id: EXCEL_BELOW_DETECTION_CLASS,
		alignment: { horizontal: "Right", vertical: "Center" },
		borders: ALL_BORDERS,
	},
];
